import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';
import BulksService from '../../services/BulksService';

const SET_BULKS = 'SET_BULKS';
const CLEAR_BULKS = 'CLEAR_BULKS';

const SET_BULK_TYPES = 'SET_BULK_TYPES';
const CLEAR_BULK_TYPES = 'CLEAR_BULK_TYPES';

const state = {
  bulks: [],
  bulkTypes: [],
};

const getters = {
  getBulks: (state) => state.bulks,
  getBulksByType: (state) => (type) => state.bulks.filter((x) => x.bulkType === type),
  getBulkTypes: (state) => state.bulkTypes,
};

const mutations = {
  [SET_BULKS](state, bulks) {
    state.bulks = bulks;
  },
  [CLEAR_BULKS](state) {
    state.bulks = [];
  },
  [SET_BULK_TYPES](state, types) {
    state.bulkTypes = types;
  },
  [CLEAR_BULK_TYPES](state) {
    state.bulkTypes = [];
  },
};

const actions = ({
  loadBulks({ commit }, activeSiteId) {
    return BulksService.getBulks(activeSiteId)
      .then((x) => x.data)
      .then((bulksData) => commit(SET_BULKS, bulksData.bulks))
      .catch((err) => console.error(err));
  },
  loadBulkTypes({ commit }) {
    return BulksService.getBulkTypes()
      .then((x) => x.data)
      .then((bulkTypes) => commit(SET_BULK_TYPES, bulkTypes))
      .catch((err) => console.error(err));
  },
  createBulk({ dispatch }, bulk) {
    return BulksService.createBulk(bulk)
      .then((x) => x.data)
      .then((bulkData) => {
        dispatch('loadBulks', bulkData.bulk.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  updateBulk({ dispatch }, bulkUpdate) {
    return BulksService.updateBulk(bulkUpdate)
      .then((x) => x.data)
      .then((bulkData) => {
        dispatch('loadBulks', bulkData.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  deleteBulk({ dispatch, rootState }, id) {
    const activeSiteId = rootState.userStore.activeSite
      ? rootState.userStore.activeSite.id
      : rootState.userStore.user.activeSite.id;

    return BulksService.deleteBulk(id)
      .then((x) => dispatch('loadBulks', activeSiteId))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
